import React from 'react';
import styles from '../VideoAnalyzer.module.css';

const MetricCard = ({ icon, title, value, message, progress }) => (
    <div className={styles.metricCard}>
        <div className={`${styles.metricIcon} ${value > 30 ? styles.active : ''}`}>
            {icon}
            <svg className={styles.progressRing} viewBox="0 0 36 36">
                <circle
                    cx="18"
                    cy="18"
                    r="16"
                    className={styles.progressBg}
                />
                <circle
                    cx="18"
                    cy="18"
                    r="16"
                    className={styles.progressPath}
                    style={{
                        strokeDasharray: `${progress}, 100`
                    }}
                />
            </svg>
        </div>  
        {/* <div className={styles.metricInfo}>
            <h4>{title}</h4>
            <p>{message}</p>
        </div> */}
    </div>
);

export default MetricCard;